import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { PageTitlesTranslation } from '@/assets/locales/pageTitles/pageTitles.translation.en.ts';
import { MenuItemEnum } from '@/components/layout/sidebar/sideBarMenu/model/SideBarMenuItems.model';
import { emptyFunction } from '@/utils/emptyFunction.util.ts';

export interface PageContextProps {
  pageDetails: PageDetailsModel;
  setPageDetails: Dispatch<SetStateAction<PageDetailsModel>>;
}

export type PageDetailsModel = {
  title: keyof PageTitlesTranslation;
};

const PageContextDefaultValues: PageContextProps = {
  pageDetails: { title: MenuItemEnum.EMPLOYEE_PROFILES_SEARCH },
  setPageDetails: emptyFunction,
};
export const PageContext = createContext<PageContextProps>(PageContextDefaultValues);

export const usePageContext = (): PageContextProps => {
  return useContext<PageContextProps>(PageContext);
};
